'use strict';
var tracker = require('./tracking');
var config = require('./config');
var $ = require('jquery');
var modalView = require('./modal');
var modalShareView = require('./modal_share');
var basepath = require('./basepath');

var restartCallback;

var $resultsSticky = $('.results-sticky');

$('.retake-button').on('click', function() {
    tracker.trackEvent({
        category: 'Chair Selector',
        action: 'take the quiz',
        label: 'start over - Bottom CTA'
    });
    if (restartCallback) {
        restartCallback();
    }
});

$('.share-share-button').on('click', function() {
    modalShareView.show();
});

$('.footer-button.shop-button').on('click', function() {
    tracker.trackEvent({
        category: 'Chair Selector',
        action: 'go to store - Bottom CTA',
        label: 'store homepage'
    });
});

//row templates
var ImageRowTemplate = '';
ImageRowTemplate += '<div></div>';


function makeTextCell(str) {
    return $('<td><div class="attribute-text-value">' + str + '</div></td>');
}

function makeSwatchCell(img, shop_now_link, buttonTag) {
    //</a>'
    var html = '';
    html += '<td>';
    html += '   <div class="color-swatches-container">';
    html += '       <a class="' + buttonTag + '"href="' + shop_now_link + '" ">';

    html += '           <img class="color-swatches-image" src="' + basepath.getPath('media/chair_detail/swatches/' + img) + '">';
    html += '           <img class="color-swatches-more more-grey" src="' + basepath.getPath('media/icons/more-grey.svg') + '">';
    html += '           <img class="color-swatches-more more-black" src="' + basepath.getPath('media/icons/more-black.svg') + '">';
    html += '       </a>';
    html += '   </div>';
    html += '</td>';


    return $(html);
}


function makeAttributeCell(attributeValue,copy) {
    if (attributeValue === 'yes') {
        return makeYesCell();
    } else if (attributeValue === 'no') {
        return makeNoCell();
    } else if (attributeValue === 'optional') {
        return makeOptionalCell();
    } else if (attributeValue === 'optional_with_copy') {
        return makePartialOptional(copy);
    } else {
        return makePartialCell(attributeValue);
    }
}


var emailShareBody = '';
$('.email-share-button').on('click', function() {
    tracker.trackShare('email');
    shareByEmail();
});

$('.print-share-button').on('click', function() {
    tracker.trackShare('print');

    var $table = $('.results-chairs-container').find('table');
    // $('.results-container').prepend($table);

    // $('.results-chairs-container').prepend($table);
    window.print();
});

function shareByEmail() {
    var subject = 'I found the right Herman Miller office chairs for me';
    var body_message = emailShareBody;
    // body_message += '%0D%0A %0D%0A';
    // body_message += 'Find the right chair for you at ' + config.getConfigData().share_base_url + '.';

    var mailto_link = 'mailto:?subject=' + subject + '&body=' + body_message;

    // window.open(mailto_link, 'emailWindow');
    document.location.href = mailto_link;
    // if (win && win.open && !win.closed) {
    //     win.close();
    // }


    // window.location='mailto:?subject=Interesting information&body=I thought you might find this information interesting:';
    // <a class="email" title="Email a friend" href="#" onclick="javascript:window.location='mailto:?subject=Interesting information&body=I thought you might find this information interesting: ' + window.location;">Email</a>
}



function makeYesCell() {
    var html = '';
    html += '    <div class="results-checkmark">';
    html += '       <img src="' + basepath.getPath('media/icons/green-check.svg') + '">';
    html += '    </div>';
    return $('<td>' + html + '</td>');
}

function makeNoCell() {
    var html = '';
    html += '    <div class="results-no-container">';
    html += '       <div class="results-no"></div>';
    html += '    </div>';
    return $('<td>' + html + '</td>');
}

function makeOptionalCell() {
    var html = '';
    html += '    <div class="results-checkmark">';
    html += '       <img src="' + basepath.getPath('media/icons/grey-plus-icon.svg') + '">';
    html += '       <div class="optional-label">Optional</div>';
    html += '    </div>';
    return $('<td>' + html + '</td>');
}

function makePartialOptional(infoText) {
    var html = '';
    html += '    <div class="hover-info">';
    html += '       <div class="info-background">';
    html += '           <p>' + infoText + '</p>';
    html += '       </div>';
    html += '       <div class="info-triangle"><img src="' + basepath.getPath('media/icons/info-bubble-drop.svg') + '"></div>';
    html += '    </div>';
    html += '    <div class="info-rollover results-checkmark">';
    html += '       <img src="' + basepath.getPath('media/icons/blue-optional.svg') + '">';
    html += '       <div class="info-hit-area"></div>';
    html += '       <div class="optional-label optional-label-with-copy">Optional</div>';
    html += '    </div>';
    return $('<td class="info-cell">' + html + '</td>');
}

function makePartialCell(infoText) {
    var html = '';
    html += '    <div class="hover-info">';
    html += '       <div class="info-background">';
    html += '           <p>' + infoText + '</p>';
    html += '       </div>';
    html += '       <div class="info-triangle"><img src="' + basepath.getPath('media/icons/info-bubble-drop.svg') + '"></div>';
    html += '    </div>';
    html += '    <div class="info-rollover results-checkmark">';
    html += '       <img src="' + basepath.getPath('media/icons/blue-check.svg') + '">';
    html += '        <div class="info-hit-area"></div>';
    html += '    </div>';
    return $('<td class="info-cell">' + html + '</td>');
}

function setToggle($tableEl, buttonSelector, sectionSelector) {

    var $buttons = $tableEl.find(buttonSelector + ' .collapse-toggle');
    $buttons.on('click', function() {
        $tableEl.find(sectionSelector).toggle(); //slideToggle('slow');
        $buttons.find('.collapse-img').toggleClass('closed-collapse');
        // $buttons.find('img').toggle();
        // toggleSection('.attr-section-overview');
    });
}



function makeSectionHeader(sectionTitle, tag) {
    var jstag = tag || sectionTitle.toLowerCase();
    //full-size-title-row
    //mini-size-title-row
    var htmlCombined = '';

    function makeHTML(mini) {
        var sizeClass = mini === true ? 'mini-size-title-row' : 'full-size-title-row';
        var colspan = mini === true ? 2 : 5;

        var html = '';
        html += '  <tbody class="' + sizeClass + ' attribute-section-title-container ' + jstag + '-title-container">';
        html += '      <tr>';
        html += '          <td class="section-title-column" colspan="' + colspan + '">';
        html += '              <div class="section-title-container">';
        html += '                  <div class="section-title-container-inner">';
        html += '                      <span class="attribute-section-title">' + sectionTitle + '</span>';
        html += '                      <div class="info-icon-container">';
        html += '                           <img class="questionmark-icon" src="' + basepath.getPath('media/icons/ic_help_blue_24px.svg') + '">';
        html += '                           <img class="questionmark-icon-dark" src="' + basepath.getPath('media/icons/ic_help_darkblue_24px.svg') + '">';
        html += '                      </div>';
        html += '                  </div>';
        html += '              </div>';
        html += '              <div class="collapse-container">';
        html += '                  <div class="collapse-button collapse-toggle">';
        html += '                       <img class="collapse-img collapse-img-grey" src="' + basepath.getPath('media/icons/collapse.svg') + '">';
        html += '                       <img class="collapse-img collapse-img-black" src="' + basepath.getPath('media/icons/collapse-black.svg') + '">';
        // html += '                       <img class="collapse-left" src="media/icons/collapse.svg">';
        html += '                  </div>';
        html += '              </div>';
        html += '          </td>';
        html += '      </tr>';
        html += '  </tbody>';
        return html;
    }
    htmlCombined += makeHTML(false);
    htmlCombined += makeHTML(true);

    return htmlCombined;
}
/*• Based on your answers, we recommend the ____ Chair, ____ Chair, or ____ Chair.
• From what you’ve told us, the ____ Chair, ____ Chair, or ____ Chair will work best for you.
• Your answers make us think that the _____ Chair, _____ Chair, or _____ Chair would be a good match for you.
• What you’re looking for in an office chair sounds a lot like what the _____ Chair, _____ Chair, or _____ Chair delivers.*/
function getResultsText() {
    var mobile = '';
    var normal = '';

    var index = Math.floor(Math.random() * 4);

    //original:
    //mobile = 'We think you would love the <span class="chair-suggestion-title chair-title-1"></span>, and <span class="chair-suggestion-title chair-title-2"></span>';
    //normal = 'We think you would love the <span class="chair-suggestion-title chair-title-1"></span>, <span class="chair-suggestion-title chair-title-2"></span>, or <span class="chair-suggestion-title chair-title-3"></span>';

    switch (index) {
        case 0:
            mobile = 'Based on your answers, we recommend the <span class="chair-suggestion-title chair-title-1"></span> or <span class="chair-suggestion-title chair-title-2"></span>.';
            normal = 'Based on your answers, we recommend the <span class="chair-suggestion-title chair-title-1"></span>, <span class="chair-suggestion-title chair-title-2"></span>, or <span class="chair-suggestion-title chair-title-3"></span>';
            break;
        case 1:
            mobile = 'From what you’ve told us, the <span class="chair-suggestion-title chair-title-1"></span> or <span class="chair-suggestion-title chair-title-2"></span> will work best for you.';
            normal = 'From what you’ve told us, the <span class="chair-suggestion-title chair-title-1"></span>, <span class="chair-suggestion-title chair-title-2"></span>, or <span class="chair-suggestion-title chair-title-3"></span> will work best for you.';
            break;
        case 2:
            mobile = 'Your answers make us think that the <span class="chair-suggestion-title chair-title-1"></span> or <span class="chair-suggestion-title chair-title-2"></span> would be a good match for you.';
            normal = 'Your answers make us think that the <span class="chair-suggestion-title chair-title-1"></span>, <span class="chair-suggestion-title chair-title-2"></span>, or <span class="chair-suggestion-title chair-title-3"></span> would be a good match for you.';
            break;
        case 3:
            mobile = 'What you’re looking for in an office chair sounds a lot like what the <span class="chair-suggestion-title chair-title-1"></span> or <span class="chair-suggestion-title chair-title-2"></span> delivers.';
            normal = 'What you’re looking for in an office chair sounds a lot like what the <span class="chair-suggestion-title chair-title-1"></span>, <span class="chair-suggestion-title chair-title-2"></span>, or <span class="chair-suggestion-title chair-title-3"></span> delivers.';
            break;
    }


    // return {
    //     mobile: mobile,
    //     normal: normal
    // };
}

function buildResultsView(chairData) {
    var resultsText = getResultsText();

    var tableHTML = '';
    tableHTML += '<table>';
    tableHTML += '  <tbody class="mini-results-title-container">';
    tableHTML += '      <tr class="mini-results-title">';
    tableHTML += '          <td colspan="2">';
    tableHTML += '              <div class="results-header-text-container">';
    tableHTML += '                  <h2 class="">Meet Your Chairs</h2>';
    // tableHTML += '                  <p class="chair-suggestion-text">' + resultsText.mobile + '</p>';
    tableHTML += '              </div>';
    tableHTML += '          </td>';
    tableHTML += '      </tr>';
    tableHTML += '  </tbody>';

    tableHTML += '  <tbody>';
    tableHTML += '      <tr class="attr-image">';
    tableHTML += '          <td class="image-row-first-cell">';
    tableHTML += '              <div class="results-header-text-container">';
    tableHTML += '                  <h2 class="">Meet Your Chairs</h2>';
    // tableHTML += '                  <p class="chair-suggestion-text">' + resultsText.normal + '</p>';
    tableHTML += '              </div>';

    tableHTML += '          </td>';
    tableHTML += '      </tr>';
    tableHTML += '      <tr class="top-actions-row hide-from-printer">';
    tableHTML += '          <td class="image-row-first-cell">';
    tableHTML += '              <button class="retake-button retake-button-small">';
    tableHTML += '                  <img class="retake-icon" src="' + basepath.getPath('media/icons/retake-red.svg') + '">';
    tableHTML += '                  <img class="retake-icon-dark" src="' + basepath.getPath('media/icons/retake-red-dark.svg') + '">';
    tableHTML += '                  <span>Start Over</span>';
    tableHTML += '              </button>';
    tableHTML += '          </td>';
    tableHTML += '      </tr>';
    tableHTML += '  </tbody>';


    tableHTML += makeSectionHeader('Overview');

    function makeAttributeRow(title, classTag) {
        var html = '';
        html += '      <tr class="mini-size-title-row-attr" ><td colspan="2">' + title + '</td></tr>';
        html += '      <tr class="' + classTag + '">';
        html += '          <td class="attribute-title-column attribute-display-name-container"><div class="attribute-display-name">' + title + '</div></td>';
        html += '      </tr>';
        return html;
    }

    tableHTML += '  <tbody class="attr-section attr-section-overview">';
    tableHTML += makeAttributeRow('Maximum Weight', 'attr-maximum_weight');
    tableHTML += makeAttributeRow('Price Range', 'attr-price_range');
    tableHTML += makeAttributeRow('Seated Comfort Range', 'attr-seated_comfort_range');
    tableHTML += makeAttributeRow('Color Range', 'attr-color_range');
    tableHTML += '  </tbody>';

    tableHTML += makeSectionHeader('Adjustability');

    tableHTML += '  <tbody class="attr-section attr-section-adjustability">';
    tableHTML += makeAttributeRow('Adjustable Seat Height', 'attr-adjustable_seat_height');
    tableHTML += makeAttributeRow('Adjustable Seat Depth', 'attr-adjustable_seat_depth');
    tableHTML += makeAttributeRow('Adjustable Arms', 'attr-adjustable_armrests');
    tableHTML += '  </tbody>';

    tableHTML += makeSectionHeader('Back Support', 'back_support');

    tableHTML += '  <tbody class="attr-section attr-section-back_support">';
    tableHTML += makeAttributeRow('Lumbar Support', 'attr-lumbar_support');
    tableHTML += makeAttributeRow('PostureFit Sacral Support', 'attr-posturefit_sacracl_support');
    tableHTML += '  </tbody>';

    tableHTML += makeSectionHeader('Tilt/Recline', 'tilt_recline');

    tableHTML += '  <tbody class="attr-section attr-section-tilt_recline">';
    tableHTML += makeAttributeRow('Synchronous Tilt', 'attr-balanced_recline');
    tableHTML += makeAttributeRow('Weight-Activated Recline', 'attr-weight_activated_recline');
    tableHTML += makeAttributeRow('Tension Control', 'attr-tension_control');
    tableHTML += makeAttributeRow('Tilt Limiter', 'attr-tilt_limiter');
    tableHTML += makeAttributeRow('Seat Angle Adjustment', 'attr-seat_angle_adjustment');
    // tableHTML += makeAttributeRow('Tilt Swivel', 'attr-tilt_swivel');
    // tableHTML += makeAttributeRow('Tilt Lock', 'attr-tilt_lock');
    tableHTML += '  </tbody>';

    tableHTML += makeSectionHeader('Family');

    tableHTML += '  <tbody class="attr-section attr-section-family">';
    // tableHTML += '      <tr class="attr-work_chair">';
    // tableHTML += '          <td><div class="attribute-display-name">Office Chair</div></td>';
    // tableHTML += '      </tr>';
    // tableHTML += '      <tr class="attr-side_chair">';
    // tableHTML += '          <td><div class="attribute-display-name">Side Chair</div></td>';
    // tableHTML += '      </tr>';
    // tableHTML += '      <tr class="attr-stool">';
    // tableHTML += '          <td><div class="attribute-display-name">Stool</div></td>';
    // tableHTML += '      </tr>';
    // tableHTML += '      <tr class="attr-lounge">';
    // tableHTML += '          <td><div class="attribute-display-name">Lounge</div></td>';
    // tableHTML += '      </tr>';
    // tableHTML += '      <tr class="attr-outdoor">';
    // tableHTML += '          <td><div class="attribute-display-name">Outdoor</div></td>';
    // tableHTML += '      </tr>';
    tableHTML += makeAttributeRow('Office Chair', 'attr-work_chair');
    tableHTML += makeAttributeRow('Side Chair', 'attr-side_chair');
    tableHTML += makeAttributeRow('Stool', 'attr-stool');
    tableHTML += makeAttributeRow('Lounge', 'attr-lounge');
    tableHTML += makeAttributeRow('Outdoor', 'attr-outdoor');
    tableHTML += '  </tbody>';

    tableHTML += '</table>';

    // var $tableEl = $('<table>');
    var $tableEl = $(tableHTML);



    setToggle($tableEl, '.overview-title-container', '.attr-section-overview');
    setToggle($tableEl, '.adjustability-title-container', '.attr-section-adjustability');

    setToggle($tableEl, '.back_support-title-container', '.attr-section-back_support');
    setToggle($tableEl, '.tilt_recline-title-container', '.attr-section-tilt_recline');

    setToggle($tableEl, '.family-title-container', '.attr-section-family');

    function setModal($tableEl, buttonSelector, callback) {

        var $button = $tableEl.find(buttonSelector + ' .info-icon-container');
        $button.css({
            'display': 'inline-block'
        });
        $button.on('click', function() {
            callback();
        });
    }

    function showModal(params) {

        modalView.show(params);
    }
    setModal($tableEl, '.overview-title-container', function() {

        showModal({
            'title': 'Overview',
            'body': 'Here’s your at-a-glance baseline information as you begin evaluating our recommendations.',
            'subjects': [{
                subtitle: 'Maximum Weight',
                body: 'The tilt mechanisms on all of our office chairs are tested and warranted to support people up to a maximum weight. People who weigh more than that maximum weight may not feel fully supported as they recline.'
            },{
                subtitle: 'Price Range',
                body: 'When buying an office chair, the functional and finish options you select will affect your final price. Price ranges span our most basic to our most fully-featured models for every chair.'
            }, {
                subtitle: 'Seated Comfort Range',
                body: 'Recommended duration of sitting for optimum comfort, based on real-world feedback.'
            }, {
                subtitle: 'Color Range',
                body: 'A range of material options allows you to personalize the look of your chair.'
            }]
        });
    });
    setModal($tableEl, '.adjustability-title-container', function() {
        showModal({
            'title': 'Adjustability',
            body: 'Ergonomic principles say that a chair should first fit the user, so many Herman Miller chairs can be adjusted to provide a personalized fit.',
            'subjects': [{
                subtitle: 'Adjustable Seat Height',
                body: 'Allows you to raise or lower the seat for optimum comfort. Proper seat height allows you to sit with your thighs parallel to the floor.'
            }, {
                subtitle: 'Adjustable Seat Depth',
                body: 'Gives you the ability to fully support your thighs without putting pressure on the backs of your knees.'
            }, {
                subtitle: 'Adjustable Armrests',
                body: 'Armrests can be adjusted to comfortably support your arms and relieve shoulder strain'
            }]
        });
    });

    setModal($tableEl, '.back_support-title-container', function() {
        showModal({
            'title': 'Back Support',
            // 'body': 'Eight out of 10 workers experience back pain at some point in their career. To combat this, Herman Miller chairs offer a choice of back support options.',
            'body': 'Proper back support is essential for healthful sitting. So we’ve got your back—in more ways than one.',
            'subjects': [{
                subtitle: 'Lumbar Support',
                body: 'Backrest supports the natural curve of your midback, or lumbar region.'
            }, {
                subtitle: 'PostureFit Sacral Support',
                body: 'PostureFit properly supports the base of your spine, or sacral region, to help your pelvis maintain a natural forward tilt to prevent slouching.'
            }]
        });
    });


    setModal($tableEl, '.tilt_recline-title-container', function() {
        showModal({
            'title': 'Tilt/Recline',
            'body': 'The act of reclining is a great way to take a micro-break from sitting. It redistributes your weight and can open up the angle of your upper and lower body, which is good for your circulation.',
            'subjects': [{
                    subtitle: 'Synchronous Tilt',
                    body: 'A synchronous tilt allows a chair’s seat and backrest to move at slightly different rates, which slightly opens up the angle of your upper and lower body as you recline. This helps your chair move the way your body wants to move throughout the day, resulting in a more comfortable long-term sit.'
                }, {
                    subtitle: 'Weight-Activated Recline',
                    body: 'Chairs such as Setu, which offer a weight-activated recline, comfortably support all people, large or small, as they lean back in their chair without the need for adjustments. These chairs are ideal for meeting spaces or other settings where different people may use the same chair throughout the day.',
                }, {
                    subtitle: 'Tension Control',
                    body: 'The Tension Control lets you adjust the amount of force needed to recline comfortably.'
                }, {
                    subtitle: 'Tilt Limiter',
                    body: 'The Tilt Limiter lets you limit the recline range between fully upright and fully reclined.'
                }, {
                    subtitle: 'Seat Angle Adjustment',
                    body: 'The Seat Angle Adjustment changes the angle of the seat slightly forward for people who like to lean in as they work.'
                }
                // {
                //     subtitle: 'Tension Control',
                //     body: 'The Tension Control lets you adjust the amount of force needed to recline comfortably.'
                // }, {
                //     subtitle: 'Tilt Limiter',
                //     body: 'The Tilt Limiter lets you limit the recline range between fully upright and fully reclined.'
                // }, {
                //     subtitle: 'Seat Angle Adjustment',
                //     body: 'The Seat Angle Adjustment changes the angle of the seat slightly forward for people who like to lean in as they work.'
                // }
                // , {
                //     subtitle: 'Tilt-Swivel',
                //     body: 'The Tilt-Swivel Mechanism allows chairs with a manual seat height adjustment (not pneumatic) to recline and rotate independently from the base.'
                // }, {
                //     subtitle: 'Tilt Lock',
                //     body: 'The Tilt Lock can be engaged to hold the chair in an upright or partially reclined position.'
                // }, {
                //     subtitle: 'Balanced Recline',
                //     body: 'Our high-performance office chairs offer a Balanced Recline, which aligns the tilt motion of the chair to the natural motion of the body, which keeps you balanced and supported as you recline.'
                // }
            ]
        });
    });

    // setModal($tableEl, '.family-title-container', function() {
    //     modalView.show({
    //         'title': 'Family',
    //         'subjects': [{
    //             subtitle: 'Work Chair',
    //             body: ''
    //         }, {
    //             subtitle: 'Side Chair',
    //             body: ''
    //         }, {
    //             subtitle: 'Stool',
    //             body: ''
    //         }, {
    //             subtitle: 'Lounge',
    //             body: ''
    //         }, {
    //             subtitle: 'Outdoor',
    //             body: ''
    //         }]
    //     });
    // });
    var $headerRow = $tableEl.find('.attr-image');
    var $topActionsRow = $tableEl.find('.top-actions-row');
    var $overview = $tableEl.find('.attr-section-overview');
    var $adjustability = $tableEl.find('.attr-section-adjustability');
    var $back_support = $tableEl.find('.attr-section-back_support');
    var $tilt = $tableEl.find('.attr-section-tilt_recline');
    var $family = $tableEl.find('.attr-section-family');

    function trackHelp(attribute) {
        tracker.trackEvent({
            category: 'Chair Selector',
            action: 'view help',
            label: attribute
        });
    }

    $tableEl.find('.overview-title-container').find('.info-icon-container').on('click', function() {
        trackHelp('Overview');
    });

    $tableEl.find('.adjustability-title-container').find('.info-icon-container').on('click', function() {
        trackHelp('Adjustability');
    });
    $tableEl.find('.back_support-title-container').find('.info-icon-container').on('click', function() {
        trackHelp('Back Support');
    });
    $tableEl.find('.tilt_recline-title-container').find('.info-icon-container').on('click', function() {
        trackHelp('Tilt/Recline');
    });

    var shopChairsHTML = '';
    // emailShareBody = 'By answering a few simple questions, I narrowed down all of my options to find an office chair that’s just right for me: the {top} from Herman Miller.';
    emailShareBody = 'Herman Miller helped me find an office chair that fits me and supports my work. By answering a few simple questions, I was able to narrow down my choices to these three:%0D%0A%0D%0A';
    chairData.forEach(function(chair, index) {
        var suggestionSelector = '.chair-title-' + (index + 1);

        emailShareBody += (chair.title_long + '%0D%0A');
        // if (index === 0) {
        //     emailShareBody = emailShareBody.replace('{top}', chair.title_long);
        // }

        $tableEl.find(suggestionSelector).html(chair.title_long);

        var imageRowHTML = '';
        imageRowHTML += '<td>';
        imageRowHTML += '   <div class="results-chair-header">';
        imageRowHTML += '       <div class="image-container"><img class="chair-image chair-image-' + index + '"" src="' + basepath.getPath(chair.image) + '"></div>';
        imageRowHTML += '       <div class="chair-detail-title">' + chair.title_long + '</div>';
        imageRowHTML += '   </div>';
        imageRowHTML += '</td>';

        $headerRow.append($(imageRowHTML));
        var buttonTag = 'chair-button-' + index;
        var buttonRowHTML = '<td class="button-cell"><a  href="' + chair.shop_now_link + '" class="selector-button ' + buttonTag + '"><span>Shop Now</span></a></td>';
        $topActionsRow.append($(buttonRowHTML));

        $topActionsRow.find('.' + buttonTag).on('click', function() {
            //Chair Selector, go to store - [button ID], [product name]
            //Button IDs values are - Top CTA, Bottom CTA, Materials
            tracker.trackEvent({
                category: 'Chair Selector',
                action: 'go to store - Top CTA',
                label: chair.title_long
            });
        });

        $overview.find('.attr-maximum_weight').append(makeTextCell(chair.overview.maximum_weight));
        $overview.find('.attr-price_range').append(makeTextCell(chair.price));
        $overview.find('.attr-seated_comfort_range').append(makeTextCell(chair.overview.seated_comfort_range));
        $overview.find('.attr-color_range').append(makeSwatchCell(chair.overview.color_swatches, chair.shop_now_link, buttonTag));

        $overview.find('.' + buttonTag).on('click', function() {
            //Chair Selector, go to store - [button ID], [product name]
            //Button IDs values are - Top CTA, Bottom CTA, Materials
            tracker.trackEvent({
                category: 'Chair Selector',
                action: 'go to store - Materials',
                label: chair.title_long
            });
        });

        $adjustability.find('.attr-adjustable_seat_height').append(makeAttributeCell(chair.adjustability.adjustable_seat_height));
        $adjustability.find('.attr-adjustable_seat_depth').append(makeAttributeCell(chair.adjustability.adjustable_seat_depth));
        $adjustability.find('.attr-adjustable_armrests').append(makeAttributeCell(chair.adjustability.adjustable_armrests));

        $back_support.find('.attr-lumbar_support').append(makeAttributeCell(chair.back_support.lumbar_support));
        $back_support.find('.attr-posturefit_sacracl_support').append(makeAttributeCell(chair.back_support.posturefit_sacracl_support.icon_type,chair.back_support.posturefit_sacracl_support.copy));

        // $tilt.find('.attr-tilt_swivel').append(makeAttributeCell(chair.tilt_recline.tilt_swivel));
        // $tilt.find('.attr-tilt_lock').append(makeAttributeCell(chair.tilt_recline.tilt_lock));
        $tilt.find('.attr-balanced_recline').append(makeAttributeCell(chair.tilt_recline.balanced_recline));
        $tilt.find('.attr-weight_activated_recline').append(makeAttributeCell(chair.tilt_recline.weight_activated_recline));
        $tilt.find('.attr-tension_control').append(makeAttributeCell(chair.tilt_recline.tension_control));
        $tilt.find('.attr-tilt_limiter').append(makeAttributeCell(chair.tilt_recline.tilt_limiter));
        $tilt.find('.attr-seat_angle_adjustment').append(makeAttributeCell(chair.tilt_recline.seat_angle_adjustment));

        $family.find('.attr-work_chair').append(makeAttributeCell(chair.family.work_chair));
        $family.find('.attr-side_chair').append(makeAttributeCell(chair.family.side_chair));
        $family.find('.attr-stool').append(makeAttributeCell(chair.family.stool));
        $family.find('.attr-lounge').append(makeAttributeCell(chair.family.lounge));
        $family.find('.attr-outdoor').append(makeAttributeCell(chair.family.outdoor));

        shopChairsHTML += '<a class="shop-chair-container ' + buttonTag + '" href="' + chair.shop_now_link + '">';
        shopChairsHTML += '       <div class="image-container-large"><img src="' + basepath.getPath(chair.image) + '"></div>';
        shopChairsHTML += '       <div class="shop-now-chair-title">' + chair.title_long + '</div>';
        shopChairsHTML += '       <div class="shop-now-link">Shop Now</div>';
        shopChairsHTML += '</a>';

        $headerRow.find('.chair-image-' + index).one('load', function() {
            // do stuff
            // console.log('chair image loaded:', index);
            //"this" points to the <img> of the chair
            $(this).fadeIn();
        }).each(function() {
            if (this.complete) {
                $(this).load();
            }
        });
    });

    emailShareBody += '%0D%0AYou can find the right chair for you at ' + config.getConfigData().share_base_url + '.';


    $tableEl.find('.attr-image').append($('<td class="table-padding-column"></td>'));
    $overview.find(' > tr').append($('<td class="table-padding-column"></td>'));
    $adjustability.find(' > tr').append($('<td class="table-padding-column"></td>'));
    $back_support.find(' > tr').append($('<td class="table-padding-column"></td>'));
    $tilt.find(' > tr').append($('<td class="table-padding-column"></td>'));
    $family.find(' > tr').append($('<td class="table-padding-column"></td>'));
    /*var $headerRow = $tableEl.find('.attr-image');
    var $overview = $tableEl.find('.attr-section-overview');
    var $adjustability = $tableEl.find('.attr-section-adjustability');
    var $back_support = $tableEl.find('.attr-section-back_support');
    var $tilt = $tableEl.find('.attr-section-tilt_recline');
    var $family = $tableEl.find('.attr-section-family');*/


    $tableEl.find('.retake-button').on('click', function() {
        tracker.trackEvent({
            category: 'Chair Selector',
            action: 'take the quiz',
            label: 'start over - Top CTA'
        });
        if (restartCallback) {
            restartCallback();
        }
    });


    var $shopChairs = $(shopChairsHTML);



    ///stick
    var stickyHTML = '';
    stickyHTML += '<table class="sticky-container-table">';

    stickyHTML += '  <tbody>';
    stickyHTML += '      <tr class="attr-image">';
    stickyHTML += '          <td class="image-row-first-cell">';
    stickyHTML += '          </td>';

    chairData.forEach(function(chair, index) {
        var suggestionSelector = '.chair-title-' + (index + 1);
        var buttonTag = 'chair-button-' + index;

        $tableEl.find(suggestionSelector).html(chair.title_long);


        stickyHTML += '<td>';
        stickyHTML += '   <div class="results-chair-header">';
        stickyHTML += '       <div class="chair-detail-title">' + chair.title_long + '</div>';
        stickyHTML += '       <a href="' + chair.shop_now_link + '" class="selector-button ' + buttonTag + '"><span>Shop Now</span></a>';
        stickyHTML += '   </div>';
        stickyHTML += '</td>';
    });
    stickyHTML += '<td class="table-padding-column"></td>';
    stickyHTML += '      </tr>';
    stickyHTML += '  </tbody>';
    var $resultsStickyContent = $(stickyHTML);

    var showingSticky = false;

    $resultsSticky.css({
        top: '-110px'
    });

    function handleAppended() {
        $('.info-cell').each(function(index, el) {
            var touchtimeout;
            // var debounce = false;
            // var debounceTimer;

            var $el = $(el);
            var $info = $el.find('.hover-info');
            var $over = $el.find('.info-hit-area');

            $info.css({
                top: $info.height() * -1 + 18
            });
            $over.on('touchstart', function() {

                $info.fadeIn();
                clearTimeout(touchtimeout);
                touchtimeout = setTimeout(function() {

                    $info.fadeOut();

                }, 3000);
            });
            $over.on('mouseover', function() {
                $info.stop();

                $info.fadeIn();
            });
            $over.on('mouseout', function() {
                $info.stop();
                $info.fadeOut('fast');
            });
        });

        chairData.forEach(function(chair, index) {
            var buttonTag = 'chair-button-' + index;
            var $shopChairsContainer = $('.results-shop-chairs-container');

            $shopChairsContainer.find('.' + buttonTag).on('click', function() {
                tracker.trackEvent({
                    category: 'Chair Selector',
                    action: 'go to store - Bottom CTA',
                    label: chair.title_long
                });


            });

            var $resultssticky = $('.results-sticky');
            $resultssticky.find('.' + buttonTag).on('click', function() {
                tracker.trackEvent({
                    category: 'Chair Selector',
                    action: 'go to store - StickyNav CTA',
                    label: chair.title_long
                });
            });
        });
        //StickyNav CTA,
        // $('.hover-info').each(function (index, el) {
        //     var $el = $(el);
        //     $el.css({
        //         top: $el.height() * -1 + 18
        //     });


        // });



    }



    function containSticky(top, bottom) {
        var maxY = bottom - $resultsSticky.height();
        var diff = top - maxY;


        if (diff >= 0) {

            $resultsSticky.finish();
            $resultsSticky.css({
                top: diff * -1
            });
        } else if (showingSticky === true) {
            if ($resultsSticky.is(':animated') === false) {
                $resultsSticky.css({
                    top: 0
                });
            }
        }
    }

    function showSticky(doShow) {

        if (doShow && !showingSticky) {

            $resultsSticky.animate({
                top: '0px'
            }, 500);
        } else if (!doShow && showingSticky) {

            // $('.results-sticky').fadeOut('fast');
            $resultsSticky.animate({
                top: '-110px'
            }, 500);
        }
        showingSticky = doShow;
    }


    return {
        $tableEl: $tableEl,
        $shopChairs: $shopChairs,
        $resultsStickyContent: $resultsStickyContent,
        handleAppended: handleAppended,
        containSticky: function(top, bottom) {
            containSticky(top, bottom);
        },
        showSticky: function(doShow) {
            showSticky(doShow);
        }
    };
}



var api = {

    make: function(chairData) {
        return buildResultsView(chairData);
    },

    onRestart: function(callback) {
        restartCallback = callback;
    }
};

module.exports = api;
